import { Component, HostBinding } from '@angular/core';

@Component({
  selector: 'app-footer',
  templateUrl: 'footer.component.html',
})
export class FooterComponent {
  test: Date = new Date();
}
